<template>
  <div class="gstin-verification-page">
    <nav class="navbar">
      <div class="logo">
        <svg
          width="240"
          height="64"
          viewBox="0 0 240 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.0731 18.8443C41.7456 17.5485 39.1087 16.8802 36.243 16.8802H24.7803C24.3498 16.8802 24 17.2348 24 17.6713V46.3142C24 46.7507 24.3498 47.1053 24.7803 47.1053H36.1219C39.0145 47.1053 41.6784 46.4506 44.0193 45.1412C46.3603 43.8318 48.2304 42.0178 49.5758 39.7127C50.9212 37.4213 51.5938 34.8161 51.5938 31.9927C51.5938 29.1557 50.9212 26.5642 49.5892 24.2728C48.2573 21.9814 46.4007 20.1537 44.0731 18.8443ZM46.5352 32.0473C46.5352 33.9978 46.0778 35.7982 45.1898 37.3667C44.2884 38.9489 43.0641 40.2037 41.5169 41.0903C39.9697 41.9905 38.2207 42.4406 36.3237 42.4406H29.7582C29.3277 42.4406 28.9779 42.086 28.9779 41.6495V22.3496C28.9779 21.9132 29.3277 21.5585 29.7582 21.5585H36.1623C38.0862 21.5585 39.8621 22.0223 41.4362 22.9225C43.0103 23.8363 44.2615 25.0912 45.1764 26.6733C46.0778 28.2555 46.5352 30.0559 46.5352 32.0473Z"
            fill="#0A2E57"
          />
          <path
            d="M76.7642 33.507C77.9078 31.8157 78.4728 29.7152 78.4728 27.2464C78.4728 23.9593 77.41 21.3815 75.3112 19.5811C73.2393 17.7943 70.2794 16.8941 66.5258 16.8941H55.5206C55.09 16.8941 54.7402 17.2487 54.7402 17.6852V46.3281C54.7402 46.7646 55.09 47.1192 55.5206 47.1192H58.9513C59.3818 47.1192 59.7316 46.7646 59.7316 46.3281V38.8127C59.7316 38.3763 60.0814 38.0217 60.5119 38.0217H66.5393C66.7949 38.0217 67.0909 38.008 67.4272 37.9944C67.7098 37.9807 67.9788 38.1171 68.1268 38.3626L73.3469 46.7509C73.4949 46.9828 73.7371 47.1192 74.0062 47.1192H77.8943C78.5132 47.1192 78.8899 46.4099 78.5267 45.8916L72.9837 37.7216C72.7146 37.326 72.8626 36.7941 73.2662 36.5759C74.7327 35.8257 75.9031 34.8027 76.7642 33.507ZM73.6698 27.3692C73.6698 29.3606 73.0913 30.82 71.8804 31.8157C70.6696 32.825 68.8668 33.3433 66.5393 33.3433H60.5119C60.0814 33.3433 59.7316 32.9887 59.7316 32.5522V22.3226C59.7316 21.8861 60.0814 21.5315 60.5119 21.5315H66.5393C68.8802 21.5315 70.6696 22.0362 71.8939 23.0182C73.0913 24.0275 73.6698 25.4324 73.6698 27.3692Z"
            fill="#0A2E57"
          />
          <path
            d="M84.8648 47.1053H88.2955C88.7261 47.1053 89.0759 46.7507 89.0759 46.3142V17.6713C89.0759 17.2348 88.7261 16.8802 88.2955 16.8802H84.8648C84.4343 16.8802 84.0845 17.2348 84.0845 17.6713V46.3142C84.0845 46.7507 84.4343 47.1053 84.8648 47.1053Z"
            fill="#0A2E57"
          />
          <path
            d="M95.6551 47.1053H99.0858C99.5163 47.1053 99.8661 46.7507 99.8661 46.3142V17.6713C99.8661 17.2348 99.5163 16.8802 99.0858 16.8802H95.6551C95.2246 16.8802 94.8748 17.2348 94.8748 17.6713V46.3142C94.8748 46.7507 95.2246 47.1053 95.6551 47.1053Z"
            fill="#0A2E57"
          />
          <path
            d="M113.764 19.5944C111.719 17.794 108.799 16.8802 105.099 16.8802H103.472C103.041 16.8802 102.691 17.2348 102.691 17.6713V20.7811C102.691 21.2175 103.041 21.5722 103.472 21.5722L104.925 21.5585C107.266 21.5585 109.055 22.0632 110.279 23.0452C111.477 24.0136 112.055 25.4322 112.055 27.369C112.055 29.3603 111.477 30.8198 110.266 31.8291C109.055 32.8384 107.252 33.3567 104.925 33.3567H103.458C103.028 33.3567 102.678 33.7113 102.678 34.1478V37.2303C102.678 37.6668 103.028 38.0214 103.458 38.0214H105.086C108.759 38.0214 111.678 37.0666 113.737 35.198C115.809 33.3158 116.872 30.6288 116.872 27.2462C116.885 23.9864 115.836 21.4221 113.764 19.5944Z"
            fill="#0A2E57"
          />
          <path
            d="M134.617 31.9791C135.828 30.9698 137.631 30.4515 139.958 30.4515H141.425C141.855 30.4515 142.205 30.0969 142.205 29.6604V26.5643C142.205 26.1278 141.855 25.7732 141.425 25.7732H139.797C136.124 25.7732 133.204 26.7279 131.146 28.5965C129.074 30.4788 128.011 33.1658 128.011 36.5484C128.011 39.8082 129.061 42.3724 131.133 44.2001C133.178 46.0005 136.097 46.9144 139.797 46.9144H141.425C141.855 46.9144 142.205 46.5598 142.205 46.1233V43.0135C142.205 42.577 141.855 42.2224 141.425 42.2224L139.972 42.236C137.631 42.236 135.841 41.7314 134.617 40.7493C133.42 39.7809 132.841 38.3624 132.841 36.4256C132.828 34.4479 133.42 32.9885 134.617 31.9791Z"
            fill="#0A2E57"
          />
          <path
            d="M115.996 51.143L119.279 51.975C119.696 52.0842 120.1 51.825 120.207 51.4022L129.45 13.7981C129.558 13.3753 129.302 12.9661 128.885 12.857L125.602 12.025C125.185 11.9158 124.782 12.175 124.674 12.5978L115.431 50.2019C115.337 50.6111 115.593 51.0339 115.996 51.143Z"
            fill="#26B67F"
          />
        </svg>
      </div>
      <div class="nav-right">
        <div class="support-block">
          <div class="support-agent">
            <svg
              class="support-agent-icon"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="18" cy="18" r="18" fill="#e8f0fb" />
              <path
                d="M18 10a5 5 0 1 1 0 10A5 5 0 0 1 18 10zm0 12c5.33 0 8 2.67 8 4v2H10v-2c0-1.33 2.67-4 8-4z"
                fill="#0a2e57"
              />
              <path
                d="M25 18a1 1 0 0 1 1 1v2a3 3 0 0 1-2 2.83V25a1 1 0 0 1-2 0v-1a3 3 0 0 1-2-2.83v-2a1 1 0 0 1 1-1h4z"
                fill="#26B67F"
                opacity="0.7"
              />
            </svg>
            <div class="support-text">
              <strong>Need assistance?</strong>
              <span>Contact our sales agent</span>
            </div>
          </div>
          <div class="divider-vertical"></div>
          <!-- <div class="contact-info">
            <div class="contact-row">
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4zm2 0v.01L10 11l6-6.99V4H4zm0 2.24V16h12V6.24l-5.4 6.3a1 1 0 0 1-1.2 0L4 6.24z"
                  fill="#0a2e57"
                />
              </svg>
              {{ supportEmail }}
            </div>
            <div class="contact-row">
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 4a1 1 0 0 1 1-1h3a1 1 0 0 1 .97.757l.75 3a1 1 0 0 1-.274.95L7.07 8.1a9.042 9.042 0 0 0 4.83 4.83l.393-1.38a1 1 0 0 1 .95-.274l3 .75A1 1 0 0 1 17 13v3a1 1 0 0 1-1 1C8.268 17 3 11.732 3 5V4z"
                  fill="#0a2e57"
                />
              </svg>
              {{ supportPhone }}
            </div>
          </div> -->
        </div>
        <div class="avatar-group" v-if="companyName">
          <div class="avatar">{{ initials }}</div>
          <div class="avatar-company">
            <small>Company</small>
            <strong>{{ companyName }}</strong>
          </div>
        </div>
      </div>
    </nav>

    <div class="main-content">
      <h1 class="page-title">GSTIN Authentication</h1>

      <!-- Info box — always visible -->
      <div class="info-box">
        <h3>What happens when you click Authenticate?</h3>
        <ol>
          <li>You'll be redirected to a new tab.</li>
          <li>
            Authenticate all your primary GSTIN credentials to allow us to fetch
            your information.
          </li>
          <li>Refresh the page to check authentication progress.</li>
          <li>
            Once the fetch is complete, you can close this tab, your data will
            stay up to date automatically.
          </li>
        </ol>
      </div>

      <!-- Section header row -->
      <div class="gstin-section-row">
        <p class="gstin-section-desc">
          Authenticate the GSTINs that are identified as primary revenue
          registrations.
        </p>
        <button
          class="btn-check-status"
          @click="fetchGstDetails"
          :disabled="loading"
        >
          <svg
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 2a6 6 0 1 1-4.24 1.76"
              stroke="#26B67F"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M2 2v4h4"
              stroke="#26B67F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Check Status
        </button>
      </div>

      <!-- OTP alert — always visible -->
      <div class="alert-info">
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <circle
            cx="10"
            cy="10"
            r="9"
            stroke="#2196f3"
            stroke-width="1.5"
            fill="none"
          />
          <rect x="9" y="9" width="2" height="5" rx="1" fill="#2196f3" />
          <rect x="9" y="6" width="2" height="2" rx="1" fill="#2196f3" />
        </svg>
        <div>
          An OTP will be sent to the mobile number registered with each GSTIN on
          the GST portal. Please ensure you have access before verifying.
        </div>
      </div>

      <!-- GSTIN rows -->
      <div class="gstin-list">
        <div v-if="loading" class="loading-state">Loading GSTIN details...</div>
        <div v-else-if="gstins.length === 0" class="empty-state">
          No GSTINs found.
        </div>
        <template v-else>
          <div class="gstin-row" v-for="(g, i) in gstins" :key="i">
            <div class="gstin-info">
              <div class="gstin-id">{{ g.gst_no || g.id }}</div>
              <div class="gstin-state" v-if="g.state">{{ g.state }}</div>
            </div>
            <span
              class="badge-authenticated"
              v-if="isAuthenticated(g.record_status)"
            >
              <svg
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="7" cy="7" r="6" fill="#0e8436" />
                <path
                  d="M4 7l2 2 4-4"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Authenticated
            </span>
            <a
              class="btn-authenticate"
              :href="g.cred_link"
              target="_blank"
              rel="noopener noreferrer"
              v-else
            >
              Authenticate
            </a>
          </div>
        </template>
      </div>

      <!-- Footer note — always visible -->
      <p class="footer-note">
        You can close this page once all relevant GSTINs are Authenticated.
      </p>
    </div>
  </div>
</template>

<script>
import accountService from '@/services/accounts'

export default {
  name: 'GstVerification',
  data() {
    return {
      token: '',
      userId: null,
      companyName: '',
      supportEmail: 'xyz@dripcapital.com',
      supportPhone: '+91-1234567890',
      gstins: [],
      loading: false,
      defaultGstPortalUrl: ''
    }
  },
  computed: {
    initials() {
      if (!this.companyName) return ''
      const skip = new Set([
        'pvt',
        'ltd',
        'llp',
        'inc',
        'co',
        'corp',
        'and',
        '&',
        'of',
        'the'
      ])
      const words = this.companyName
        .split(/[\s.]+/)
        .filter((w) => w && !skip.has(w.toLowerCase()))
      return words
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join('')
    }
  },
  async created() {
    this.token = this.$route.query.token
    if (this.token) {
      await this.fetchUserData()
    }
  },
  methods: {
    async fetchUserData() {
      this.loading = true
      try {
        const res = await accountService.fetchLoggedUser(this.token)
        const userData = res.data
        if (userData) {
          this.userId = userData.id

          let account = userData.linked_users && userData.linked_users[0]
          this.companyName = userData.company
          if (account) {
            if (account.am) {
              this.supportEmail = account.am.email || this.supportEmail
              this.supportPhone = account.am.phone || this.supportPhone
            }
          }

          if (this.userId) {
            await this.fetchGstDetails()
          }
        }
      } catch (error) {
        console.error('Error fetching user data', error)
        this.$notify({
          title: 'Error fetching user data',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async fetchGstDetails() {
      if (!this.userId || !this.token) return

      this.loading = true
      try {
        const res = await accountService.fetchGstDetails(
          this.userId,
          this.token
        )
        if (res.data) {
          // Assuming the API returns an array or an object with a list of GSTINs
          let list = Array.isArray(res.data)
            ? res.data
            : res.data.gst_details || res.data.gstins || []

          this.gstins = list
            .map((g) => {
              let state = g.state
              const rawData = g.raw_data || g.rawData

              if (typeof rawData === 'string') {
                try {
                  // Convert Ruby rocket syntax (=>) into valid JSON format (:)
                  const jsonString = rawData.replace(/=>/g, ':')
                  const data = JSON.parse(jsonString)

                  if (data && data.state) {
                    state = data.state
                  }
                } catch (error) {
                  console.error('Error parsing rawData:', error.message)
                }
              }

              return {
                ...g,
                state: state
              }
            })
            .filter((g) => g.cred_link)
        }
      } catch (error) {
        console.error('Error fetching GST details', error)
        this.$notify({
          title: 'Error fetching GST details',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    isAuthenticated(status) {
      if (!status) return false
      return status.toLowerCase() === 'completed'
    }
  }
}
</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.gstin-verification-page {
  --color-text-primary: #0a2e57;
  --color-text-subdued: #4b4b4b;
  --color-text-success: #0b6328;
  --color-fill-light-warning: #fcf0d8;
  --color-fill-light-success: #b9ebc9;
  --color-stroke-success: #0e8436;
  --color-stroke-subdued: #dedede;
  --color-stroke-neutral: #b5b5b5;
  --color-surface-1: #ffffff;
  --color-accent: #26b67f;

  font-family: 'Nunito Sans', sans-serif;
  background: #fff;
  min-height: 100vh;
}

/* ── Navbar ── */
.navbar {
  border-bottom: 1px solid var(--color-stroke-subdued);
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  gap: 16px;
}
.logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.logo svg {
  height: 40px;
}

.nav-right {
  display: flex;
  align-items: center;
}

.support-block {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px;
}
.support-agent {
  display: flex;
  align-items: center;
  gap: 12px;
}
.support-agent-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}
.support-text {
  display: flex;
  flex-direction: column;
}
.support-text strong {
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1.4;
}
.support-text span {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1.4;
}
.divider-vertical {
  width: 1px;
  height: 52px;
  background: var(--color-stroke-subdued);
  flex-shrink: 0;
}
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.contact-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: var(--color-text-primary);
}
.contact-row svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.avatar-group {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border: 1px solid var(--color-stroke-subdued);
  border-radius: 8px;
  margin-left: 16px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #c8e6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-text-primary);
}
.avatar-company {
  display: flex;
  flex-direction: column;
}
.avatar-company small {
  font-size: 11px;
  font-weight: 400;
  color: var(--color-text-subdued);
}
.avatar-company strong {
  font-size: 13px;
  color: var(--color-text-primary);
}

/* ── Main ── */
.main-content {
  max-width: 1132px;
  margin: 0 auto;
  padding: 40px 24px 60px;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #000;
  text-align: center;
  margin-bottom: 24px;
}

/* Info box */
.info-box {
  background: var(--color-fill-light-warning);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}
.info-box h3 {
  font-size: 14px;
  font-weight: 700;
  color: #000;
  margin-bottom: 10px;
}
.info-box ol {
  padding-left: 20px;
  font-size: 14px;
  color: #000;
  line-height: 1.75;
}

/* Section row: description + Check Status button */
.gstin-section-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.gstin-section-desc {
  font-size: 14px;
  color: var(--color-text-subdued);
  flex: 1;
}

/* Check Status button (outlined) */
.btn-check-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 8px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  background: white;
  color: var(--color-accent);
  border: 1.5px solid var(--color-accent);
  transition: background 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
}
.btn-check-status:hover {
  background: #f0faf6;
}
.btn-check-status:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-check-status svg {
  width: 15px;
  height: 15px;
}

/* OTP Alert */
.alert-info {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  background: #e8f4fd;
  border-left: 4px solid #2196f3;
  color: var(--color-text-primary);
  margin-bottom: 12px;
}
.alert-info svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

/* GSTIN list */
.gstin-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gstin-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 0.5px solid var(--color-stroke-neutral);
  border-radius: 8px;
  background: var(--color-surface-1);
}
.gstin-info {
  flex: 1;
  min-width: 0;
}
.gstin-id {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1.4;
}
.gstin-state {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-subdued);
  line-height: 1.4;
}

/* Authenticated badge */
.badge-authenticated {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 1000px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  background: var(--color-fill-light-success);
  border: 1px solid var(--color-stroke-success);
  color: var(--color-text-success);
  height: 32px;
  flex-shrink: 0;
}
.badge-authenticated svg {
  width: 14px;
  height: 14px;
}

/* Authenticate button (filled green) */
.btn-authenticate {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  white-space: nowrap;
  background: var(--color-accent);
  color: white;
  transition: opacity 0.2s;
  flex-shrink: 0;
  text-decoration: none;
}
.btn-authenticate:hover {
  opacity: 0.88;
}

/* Footer note */
.footer-note {
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  font-weight: 700;
  color: var(--color-accent);
}

.loading-state,
.empty-state {
  padding: 20px;
  text-align: center;
  color: var(--color-text-subdued);
  font-size: 14px;
}

@media (max-width: 768px) {
  .navbar {
    padding: 12px 16px;
    flex-wrap: wrap;
    min-height: auto;
  }
  .nav-right {
    flex-wrap: wrap;
  }
  .divider-vertical {
    display: none;
  }
  .avatar-group {
    display: none;
  }
  .main-content {
    padding: 24px 16px 40px;
  }
  .page-title {
    font-size: 20px;
  }
  .gstin-row {
    flex-wrap: wrap;
  }
  .gstin-section-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
